import type { History } from 'history';
import * as React from 'react';
import { ROUTES } from '../../constants/routes';

export const createContactClickHandler =
	(
		contactId: string | undefined,
		onContactClick: ((id: string) => void) | undefined,
		history: History,
		origin = 'reporting'
	): React.MouseEventHandler =>
	event => {
		if (!contactId || !onContactClick) return;
		if (event.detail === 1) {
			// Single click: open the contact info drawer
			onContactClick(contactId);
			return;
		}
		// Double click (or more): navigate to the contact page; Ctrl/Meta opens in a new tab
		const path = `${ROUTES.contacts.people}/${contactId}?origin=${origin}`;
		if (event.ctrlKey || event.metaKey) {
			window.open(window.location.origin + `/#${path}`);
		} else {
			history.push(path);
		}
	};
